// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-item-menu_container-YMkMu {
  min-width: 220px;
}

.user-item-deleteMenuOption_text-xHPwS {
  color: var(--accent-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/business/users/user-item/user-item.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".menu_container {\n  min-width: 220px;\n}\n\n.deleteMenuOption_text {\n  color: var(--accent-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu_container": `user-item-menu_container-YMkMu`,
	"deleteMenuOption_text": `user-item-deleteMenuOption_text-xHPwS`
};
export default ___CSS_LOADER_EXPORT___;
